import { createCmsDataProviderServer } from "@providers/data-provider/cms-data-provider.server";
import { CustomDataProvider } from "@providers/data-provider/rest-data-provider";
import { transformQueryParams } from "@shared/utils";
import qs from "qs";

export class ApiInstance {
  authorization: string;
  locale: string;
  apiPath: string;
  dataProvider: CustomDataProvider;

  constructor(locale = "id-ID") {
    this.authorization = `Bearer ${process.env.CMS_TOKEN}`;
    this.locale = locale;
    this.apiPath = `/api`;
    this.dataProvider = createCmsDataProviderServer();
  }

  _Send(endpoint: string, options?: RequestInit) {
    return new Promise((resolve, reject) => {
      this.dataProvider.custom({
        method: "GET",
        url: transformQueryParams(this.apiPath + endpoint, {
          locale: this.locale,
          populate: "*"
        }),
        headers: {
          ...options?.headers,
          Authorization: this.authorization,
        }
      })
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  }

  _SendWithQuery<T>(endpoint: string, query = {}) {
    const _query = qs.stringify(
      {
        locale: this.locale,
        ...query,
      },
      { addQueryPrefix: true, encodeValuesOnly: true },
    );

    const url = this.apiPath + endpoint + _query;

    return new Promise<T>((resolve, reject) => {
      this.dataProvider.custom({
        method: "GET",
        url: url,
        headers: {
          Authorization: this.authorization,
        },
      })
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(reject);
    });
  }

  _GetCollectionWithQuery<T>(endpoint: string, query = {}) {
    const _query = qs.stringify(
      {
        locale: this.locale,
        ...query,
      },
      { addQueryPrefix: true, encodeValuesOnly: true },
    );

    const url = this.apiPath + endpoint + _query;

    return new Promise<T>((resolve, reject) => {
      this.dataProvider.custom({
        method: "GET",
        url: url,
        headers: {
          Authorization: this.authorization,
        },
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  }
}
